module.exports = __webpack_public_path__ + "static/media/IconNoRewards.41f25fcd.svg";